import { useQueryClient } from '@tanstack/react-query';

import { useToast } from '@bonusly/design-system';

import { spotlightQueryKey, spotlightsQueryKey } from '../../../queries/spotlight';
import { EmployeeSpotlight } from '../../../schemas/spotlight';
import { SpotlightCompletionToast } from '../spotlight-completion-toast';

export const useSpotlightCompletionHandler = () => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return async (data: { spotlight_id?: string; event_name?: string }) => {
		const spotlight_id = data.spotlight_id;
		if (!spotlight_id) {
			console.warn('[useSpotlightCompletionHandler] Event missing spotlight_id', { data });
			return;
		}

		// Invalidate to mark as stale, then refetch active queries
		queryClient.invalidateQueries({ queryKey: spotlightQueryKey(spotlight_id) });
		queryClient.refetchQueries({ queryKey: spotlightQueryKey(spotlight_id), type: 'active' });

		// Also invalidate the list query - try to get userId from cache
		// If not in cache, the list query will update when the spotlight query refetches
		const cachedSpotlight = queryClient.getQueryData<EmployeeSpotlight>(spotlightQueryKey(spotlight_id));
		if (cachedSpotlight?.userId) {
			queryClient.invalidateQueries({ queryKey: spotlightsQueryKey(cachedSpotlight.userId) });
		}

		// Use setTimeout to ensure toast is called after React render cycle
		setTimeout(() => {
			toast({
				title: 'Spotlight ready!',
				status: 'success',
				duration: 10000,
				isClosable: true,
				render: ({ onClose }) => <SpotlightCompletionToast spotlightId={spotlight_id} onClose={onClose} />,
			});
		}, 0);
	};
};
